import { render, staticRenderFns } from "./PDFReader.vue?vue&type=template&id=1fc077ff&scoped=true&"
import script from "./PDFReader.vue?vue&type=script&lang=js&"
export * from "./PDFReader.vue?vue&type=script&lang=js&"
import style0 from "./PDFReader.vue?vue&type=style&index=0&id=1fc077ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc077ff",
  null
  
)

export default component.exports